import {
  FETCH_STONE_CLARITY_REQUEST,
  FETCH_STONE_CLARITY_SUCCESS,
  FETCH_STONE_CLARITY_FAILURE,
  ADD_STONE_CLARITY_REQUEST,
  ADD_STONE_CLARITY_SUCCESS,
  ADD_STONE_CLARITY_FAILURE,
  UPDATE_STONE_CLARITY_REQUEST,
  UPDATE_STONE_CLARITY_SUCCESS,
  UPDATE_STONE_CLARITY_FAILURE,
  DELETE_STONE_CLARITY_REQUEST,
  DELETE_STONE_CLARITY_SUCCESS,
  DELETE_STONE_CLARITY_FAILURE,
  STONE_CLARITY_FORM_ERROR,
  STONE_CLARITY_FORM_SUCCESS,
  SET_STONE_CLARITY_EDIT,
  CLEAR_STONE_CLARITY_EDIT,
} from '../../../../types/masters/stoneAttribute/stoneClarity/stoneClarityTypes';

const initialState = {
  list: [],
  loading: false,
  error: null,
  editingStoneClarity: null,
};

const stoneClarityReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STONE_CLARITY_REQUEST:
    case ADD_STONE_CLARITY_REQUEST:
    case UPDATE_STONE_CLARITY_REQUEST:
    case DELETE_STONE_CLARITY_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_STONE_CLARITY_SUCCESS:
      return { ...state, loading: false, list: action.payload, error: null };
    case ADD_STONE_CLARITY_SUCCESS:
    case UPDATE_STONE_CLARITY_SUCCESS:
    case DELETE_STONE_CLARITY_SUCCESS:
      return { ...state, loading: false, error: null };
    case FETCH_STONE_CLARITY_FAILURE:
    case ADD_STONE_CLARITY_FAILURE:
    case UPDATE_STONE_CLARITY_FAILURE:
    case DELETE_STONE_CLARITY_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case STONE_CLARITY_FORM_ERROR:
      return { ...state, loading: false, formError: action.payload };
    case STONE_CLARITY_FORM_SUCCESS:
      return { ...state, loading: false, formSuccess: action.payload };
    case SET_STONE_CLARITY_EDIT:
      return { ...state, editingStoneClarity: action.payload };
    case CLEAR_STONE_CLARITY_EDIT:
      return { ...state, editingStoneClarity: null };
    default:
      return state;
  }
};

export default stoneClarityReducer; 